// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"00682cb4","99":"f3358848","866":"6a111172","923":"2ebde0a7"}[chunkId] + ".chunk.css";
};